"use client";
import { jsx, Fragment, jsxs } from "react/jsx-runtime";
import { Box } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Text } from "@nxt-costco-com/forge-components";
import { SpaceXxs } from "@nxt-costco-com/forge-design-tokens";
import { AddToList } from "../../../AddToList/index.js";
import { useAddToListContext } from "../../../AddToList/AddToListProvider/useAddToListContext.js";
import { ProductActions } from "../CardFooter/ProductActions/index.js";
import { childElementStyles } from "../styles.js";
import { useProductTileData } from "../../../../../hooks/useProductTileData/index.js";
import { AvailabilityInfo } from "./components/AvailabilityInfo/index.js";
import { withSponsoredStyles } from "./styles.js";
const Fulfillment = ({
  showActionButton = true,
  isInformative = true,
  pdpNavigationUrl = "",
  isCriteo = false
}) => {
  var _a;
  const { normalizedData, translationsConfig } = useProductTileData();
  const { contentStackValues } = useAddToListContext();
  const isMinWidthOrGreater = useMediaQuery("(min-width:360px)");
  const ariaDescribedBy = ((_a = contentStackValues == null ? void 0 : contentStackValues.key_value) == null ? void 0 : _a.find(
    (item) => item.key === "addtolisttitle"
  )) || { value: "Save to List" };
  const { translations, featureControls } = translationsConfig || {};
  const { hideAddToList } = featureControls || {};
  const { addToListButtonData, productInfoData } = normalizedData;
  const { productName } = productInfoData || {};
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
    Box,
    {
      sx: {
        display: "flex",
        flexDirection: "column",
        gap: SpaceXxs
      },
      children: [
        isInformative && /* @__PURE__ */ jsx(AvailabilityInfo, {}),
        showActionButton && /* @__PURE__ */ jsxs(
          Box,
          {
            sx: {
              alignItems: "center",
              display: "flex",
              flexDirection: isMinWidthOrGreater ? "row" : "column",
              gap: SpaceXxs,
              zIndex: 1
            },
            children: [
              /* @__PURE__ */ jsx(
                Box,
                {
                  sx: {
                    display: "flex",
                    flex: 1,
                    width: "100%",
                    flexDirection: "column",
                    zIndex: 2
                  },
                  children: /* @__PURE__ */ jsx(
                    ProductActions,
                    {
                      pdpNavigationUrl
                    }
                  )
                }
              ),
              !hideAddToList && /* @__PURE__ */ jsx(
                Box,
                {
                  sx: {
                    marginLeft: "auto"
                  },
                  children: /* @__PURE__ */ jsx(
                    AddToList,
                    {
                      product: {
                        href: productInfoData.productLinkUrl,
                        id: productInfoData.itemNumber,
                        price: `${addToListButtonData == null ? void 0 : addToListButtonData.price}`,
                        src: productInfoData.productImageUrl,
                        title: productInfoData.productName
                      },
                      sx: {
                        ...childElementStyles,
                        marginLeft: "auto"
                      },
                      ariaDescribedBy: `${ariaDescribedBy == null ? void 0 : ariaDescribedBy.value} ${productName || ""}`,
                      uniqueId: `AddToList_${productInfoData.partNumber}`,
                      variant: "iconV2"
                    }
                  )
                }
              )
            ]
          }
        ),
        isCriteo && /* @__PURE__ */ jsx(Box, { sx: withSponsoredStyles, children: /* @__PURE__ */ jsx(Text, { color: "light", variant: "t7", children: (translations == null ? void 0 : translations.sponsoredlabel) || "" }) })
      ]
    }
  ) });
};
export {
  Fulfillment
};
